import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display';
const API_STATIC_URL = process.env.VUE_APP_ROOT_DISPLAY_STATIC + '/logfile'

const serviceName = "Logs-Service: ";
const sortTableFields = ['createdAt'];
const sortDatabaseFields = ["createdAt"];

export default class OfferService {

  static async readAllLogsPaginated(logPath, page, size, search, sort, sortAsc, filter, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
    await WrapperService.post(API_URL + '/logs/' + logPath + '/filter?' + params,  filter, serviceName, successF, errorF);
  }

  static async readAllScheduleLogsPaginated(page, size, search, sort, sortAsc, filter, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
    await WrapperService.post(API_URL + '/schedule/filter?' + params,  filter, serviceName, successF, errorF);
  }

  static async sendJob(job, successF, errorF) {
    await WrapperService.get(API_URL + '/task/job/' + job + '/', null, serviceName, successF, errorF);
  }

  static async getJsonLog(jsonId, successF, errorF) {
    await WrapperService.get(API_URL + '/logs/json/' + jsonId, null, serviceName, successF, errorF);
  }

  static async readFileLog(id, successF, errorF) {
    await WrapperService.get(API_URL + '/logs/logfile/show/' + id, null, serviceName, successF, errorF);
  }

  static async downloadFileLog(id, onSuccess) {
    await WrapperService.get(API_STATIC_URL + '/' + id, {responseType: 'blob'}, serviceName, onSuccess);
  }

}